import type { IconData } from '@stacksjs/iconify-core'

export const analysis: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14 16a1 1 0 0 1-.707-1.707l7-7a1 1 0 0 1 1.414 1.414l-7 7A1 1 0 0 1 14 16M3 17a1 1 0 0 1-.707-1.707l6-6a1 1 0 0 1 1.414 1.414l-6 6A1 1 0 0 1 3 17\"/><path fill=\"currentColor\" d=\"M14 16a1 1 0 0 1-.707-.293l-5-5a1 1 0 0 1 1.414-1.414l5 5A1 1 0 0 1 14 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default analysis
